import React, { useRef, useState } from "react";
import SearchForm from "../../../component/search-form";
import CheckboxFilter from "../../../component/Filter/CheckboxFilter";
// Importing scrollbar library
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import moment from "moment";
import { useParams, useSearchParams } from "react-router-dom";
import {
  GET_ALL_FILE_NAME,
  GET_ALL_TODO_CUSTOM_COMPONENTS,
  GET_ALL_TODO_DATA,
  GET_ALL_TODO_PERFORMANCE,
  GET_ALL_TODO_PERFORMANCE_GROUP,
  PERFORMANCE_LOADER,
  SET_ASSET_TYPES,
} from "../../../redux/constants";
import {
  getAllActivities,
  getTodoPerformance,
} from "../../../redux/actions/todoPerformance";
import useDebounce from "../../../Hook/useDebounce";
import Tippy from "@tippyjs/react";
import { Customer } from "../../../constant/AuthenticationConstant";
import { sanitizeInput } from "../../../utils";

function ToDoList({
  setValidation,
  setAssetEntryValue,
  setActiveEntry,
  setTab,
  setPerformanceTab,
  embedded,
  setAllowBasedon,
}) {

  const todoListRef = useRef();

  const {
    activities,
    performancegroup,
    tempdata,
    tododata,
    performanceLoader,
  } = useSelector((state) => state.todoPerformance);
  const { name, id, email, user_departments, type } = useSelector(
    (state) => state.auth
  );
  const { userDetails } = useSelector((state) => state.user);
  const username = embedded ? userDetails.name : name;
  const [allactivities, setAllActivities] = useState([]);
  const [todoid, setTodoId] = useState("");
  const [activityid, setActivityID] = useState(null);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [todolock, setTodoLock] = useState();
  const { activity_assignment_id } = useParams();
  const [searchText, setSearchText] = useState();
  const [checkboxData, setCheckboxData] = useState({
    Status: [
      {
        label: "Completed",
        value: "completed",
        checked: false,
      },
      {
        label: "Pending",
        value: "pending",
        checked: false,
      },
      {
        label: "In Progress",
        checked: false,
        value: "in progress",
      },
      {
        label: "Overdue",
        checked: false,
        value: "overdue",
      },
      {
        label: "Overdue (In Progress)",
        checked: false,
        value: "overdue-inprogress",
      },
      {
        label: "Tentative",
        checked: false,
        value: "tentative",
      },
    ],
    Assignment: [
      {
        label: "To Dos assigned to me",
        checked: false,
        value: "To Dos assigned to me",
      },
    ],
  });

  useEffect(() => {
    if (searchParams.get("activity_id")) {
      setActivityID(searchParams.get("activity_id"));
      setTodoId(searchParams.get("activity_id"));
    } else {
      if (type === Customer) {
        const filteredToDo = activities.filter(
          (item) =>
            item.collaborator_id === id || Number(item.activity.is_trackable)
        );
        setActivityID(filteredToDo[0]?.activity.activity_id);
        setTodoId(filteredToDo[0]?.activity.activity_id);
      } else {
        setActivityID(activities[0]?.activity.activity_id);
        setTodoId(activities[0]?.activity.activity_id);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (activity_assignment_id && activityid) {
      dispatch({ type: PERFORMANCE_LOADER, payload: true });
      dispatch(
        getTodoPerformance(activity_assignment_id, activityid, (res) => {
          dispatch({ type: PERFORMANCE_LOADER, payload: false });
        })
      );
    }

    return () => {
      dispatch({ type: GET_ALL_TODO_DATA, payload: [] });
    };
  }, [activityid]);

  useEffect(() => {
    if (activities.length > 0) {
      setAllActivities(activities);
    }
  }, [activities]);

  useEffect(() => {
    if (activityid && todoid && Object.keys(tododata).length > 0) {
      if (
        tododata.activity.activity_id === activityid ||
        tododata.activity.activity_id === todoid
      ) {
        let files = [];
        if (tododata.todo_performance_groups.length > 0) {
          if (Object.keys(performancegroup).length === 0) {
            dispatch({
              type: GET_ALL_TODO_PERFORMANCE_GROUP,
              payload: tododata.todo_performance_groups[0],
            });
            dispatch({
              type: GET_ALL_TODO_PERFORMANCE,
              payload: tododata.todo_performance_groups[0].todo_performances,
            });
            if (
              tododata.activity.based_on === "Container" &&
              tododata.todo_performance_groups[0].todo_performances.length > 0
            ) {
              handleAssetTypes(
                tododata.todo_performance_groups[0].todo_performances
              );
            }
            if (
              tododata.todo_performance_groups[0].todo_performances.length > 0
            )
              files =
                tododata.todo_performance_groups[0].todo_performances[0].files;
          } else {
            let flag = false;
            tododata.todo_performance_groups?.forEach((item, i) => {
              if (
                item.todo_performance_group_id ===
                  performancegroup.todo_performance_group_id ||
                performancegroup.length === i + 1
              ) {
                flag = true;
                setPerformanceTab(i + 1);
                dispatch({
                  type: GET_ALL_TODO_PERFORMANCE_GROUP,
                  payload: item,
                });
                dispatch({
                  type: GET_ALL_TODO_PERFORMANCE,
                  payload: item.todo_performances,
                });
                if (
                  tododata.activity.based_on === "Container" &&
                  item.todo_performances.length > 0
                ) {
                  handleAssetTypes(item.todo_performances);
                }
                if (item.todo_performances.length > 0)
                  files = item.todo_performances[0].files;
              }
            });
            if (!flag) {
              if (tododata.todo_performance_groups.length > 0) {
                dispatch({
                  type: GET_ALL_TODO_PERFORMANCE_GROUP,
                  payload: tododata.todo_performance_groups[0],
                });
              } else {
                dispatch({
                  type: GET_ALL_TODO_PERFORMANCE_GROUP,
                  payload: {},
                });
              }
              if (
                tododata.todo_performance_groups[0].todo_performances.length > 0
              ) {
                dispatch({
                  type: GET_ALL_TODO_PERFORMANCE,
                  payload:
                    tododata.todo_performance_groups[0].todo_performances,
                });
              } else {
                dispatch({
                  type: GET_ALL_TODO_PERFORMANCE,
                  payload: [],
                });
              }

              if (
                tododata.activity.based_on === "Container" &&
                tododata.todo_performance_groups[0].todo_performances.length > 0
              ) {
                handleAssetTypes(
                  tododata.todo_performance_groups[0].todo_performances
                );
              }
              if (
                tododata.todo_performance_groups[0].todo_performances.length > 0
              )
                files =
                  tododata.todo_performance_groups[0].todo_performances[0]
                    .files;
            }
          }
        } else {
          const assetypes = [];
          tempdata.forEach((ele1) => {
            if (ele1.type !== undefined) delete ele1.type;
            assetypes.push(ele1);
          });
          dispatch({ type: SET_ASSET_TYPES, payload: assetypes });

          dispatch({
            type: GET_ALL_TODO_PERFORMANCE,
            payload: [],
          });
        }
        var filedata = provideIdtoAllFile(
          tododata.activity.activity_file_uploads,
          files
        );
        dispatch({
          type: GET_ALL_FILE_NAME,
          payload: filedata,
        });
        dispatch({
          type: GET_ALL_TODO_CUSTOM_COMPONENTS,
          payload: tododata.activity.activitycustomfields,
        });
        // setTodoId(tododata.activity.activity_id);
      } else {
        let files = [];
        if (tododata.todo_performance_groups.length > 0) {
          let groups = tododata.todo_performance_groups[0];
          dispatch({
            type: GET_ALL_TODO_PERFORMANCE_GROUP,
            payload: groups,
          });
          dispatch({
            type: GET_ALL_TODO_PERFORMANCE,
            payload: groups.todo_performances,
          });
          if (
            tododata.activity.based_on === "Container" &&
            groups.todo_performances.length > 0
          ) {
            handleAssetTypes(groups.todo_performances);
          } else {
            tempdata.forEach((ele) => {
              if (ele.type !== undefined) delete ele.type;
            });
            dispatch({ type: SET_ASSET_TYPES, payload: tempdata });
          }
          if (groups.todo_performances.length > 0)
            files = groups.todo_performances[0].files;
        } else {
          const assetypes = [];
          tempdata.forEach((ele1) => {
            if (ele1.type !== undefined) delete ele1.type;
            assetypes.push(ele1);
          });
          dispatch({ type: SET_ASSET_TYPES, payload: assetypes });
          dispatch({
            type: GET_ALL_TODO_PERFORMANCE,
            payload: [],
          });
        }
        const filedata = provideIdtoAllFile(
          tododata.activity.activity_file_uploads,
          files
        );
        dispatch({
          type: GET_ALL_FILE_NAME,
          payload: filedata,
        });
        dispatch({
          type: GET_ALL_TODO_CUSTOM_COMPONENTS,
          payload: tododata.activity.activitycustomfields,
        });
      }
    }
  }, [tododata]);

  // const handleFunction = () => {

  //   if (searchParams.get("activity_id") !== null || todoid !== "") {
  //     activities.forEach((ele) => {
  //       if (
  //         ele.activity.activity_id === searchParams.get("activity_id") ||
  //         ele.activity.activity_id === todoid
  //       ) {
  //         dispatch({ type: GET_ALL_TODO_DATA, payload: ele });
  //         let files = [];
  //         if (ele.todo_performance_groups.length > 0) {
  //           if (Object.keys(performancegroup).length === 0) {
  //             dispatch({
  //               type: GET_ALL_TODO_PERFORMANCE_GROUP,
  //               payload: ele.todo_performance_groups[0],
  //             });
  //             dispatch({
  //               type: GET_ALL_TODO_PERFORMANCE,
  //               payload: ele.todo_performance_groups[0].todo_performances,
  //             });
  //             if (
  //               ele.activity.based_on === "Container" &&
  //               ele.todo_performance_groups[0].todo_performances.length > 0
  //             ) {
  //               handleAssetTypes(
  //                 ele.todo_performance_groups[0].todo_performances
  //               );
  //             }
  //             if (ele.todo_performance_groups[0].todo_performances.length > 0)
  //               files =
  //                 ele.todo_performance_groups[0].todo_performances[0].files;
  //           } else {
  //             let flag = false;
  //             ele.todo_performance_groups?.forEach((item, i) => {
  //               if (
  //                 item.todo_performance_group_id ===
  //                   performancegroup.todo_performance_group_id ||
  //                 performancegroup.length === i + 1
  //               ) {
  //                 flag = true;
  //                 setPerformanceTab(i + 1);
  //                 dispatch({
  //                   type: GET_ALL_TODO_PERFORMANCE_GROUP,
  //                   payload: item,
  //                 });
  //                 dispatch({
  //                   type: GET_ALL_TODO_PERFORMANCE,
  //                   payload: item.todo_performances,
  //                 });
  //                 if (
  //                   ele.activity.based_on === "Container" &&
  //                   item.todo_performances.length > 0
  //                 ) {
  //                   handleAssetTypes(item.todo_performances);
  //                 }
  //                 if (item.todo_performances.length > 0)
  //                   files = item.todo_performances[0].files;
  //               }
  //             });
  //             if (!flag) {
  //               if (ele.todo_performance_groups.length > 0) {
  //                 dispatch({
  //                   type: GET_ALL_TODO_PERFORMANCE_GROUP,
  //                   payload: ele.todo_performance_groups[0],
  //                 });
  //               } else {
  //                 dispatch({
  //                   type: GET_ALL_TODO_PERFORMANCE_GROUP,
  //                   payload: {},
  //                 });
  //               }
  //               if (
  //                 ele.todo_performance_groups[0].todo_performances.length > 0
  //               ) {
  //                 dispatch({
  //                   type: GET_ALL_TODO_PERFORMANCE,
  //                   payload: ele.todo_performance_groups[0].todo_performances,
  //                 });
  //               } else {
  //                 dispatch({
  //                   type: GET_ALL_TODO_PERFORMANCE,
  //                   payload: [],
  //                 });
  //               }

  //               if (
  //                 ele.activity.based_on === "Container" &&
  //                 ele.todo_performance_groups[0].todo_performances.length > 0
  //               ) {
  //                 handleAssetTypes(
  //                   ele.todo_performance_groups[0].todo_performances
  //                 );
  //               }
  //               if (
  //                 ele.todo_performance_groups[0].todo_performances.length > 0
  //               )
  //                 files =
  //                   ele.todo_performance_groups[0].todo_performances[0].files;
  //             }
  //           }
  //         } else {
  //           dispatch({
  //             type: GET_ALL_TODO_PERFORMANCE,
  //             payload: [],
  //           });
  //         }
  //         var filedata = provideIdtoAllFile(
  //           ele.activity.activity_file_uploads,
  //           files
  //         );
  //         dispatch({
  //           type: GET_ALL_FILE_NAME,
  //           payload: filedata,
  //         });
  //         dispatch({
  //           type: GET_ALL_TODO_CUSTOM_COMPONENTS,
  //           payload: ele.activity.activitycustomfields,
  //         });
  //         setTodoId(ele.activity.activity_id);
  //       }
  //     });
  //   } else {
  //     if (type === Customer) {
  //       const filteredToDo = activities.filter(
  //         (item) =>
  //           item.collaborator_id === id || Number(item.activity.is_trackable)
  //       );
  //       dispatch({ type: GET_ALL_TODO_DATA, payload: filteredToDo[0] });
  //       let files = [];
  //       if (filteredToDo[0].todo_performance_groups.length > 0) {
  //         let groups = filteredToDo[0].todo_performance_groups[0];
  //         dispatch({
  //           type: GET_ALL_TODO_PERFORMANCE_GROUP,
  //           payload: groups,
  //         });
  //         dispatch({
  //           type: GET_ALL_TODO_PERFORMANCE,
  //           payload: groups.todo_performances,
  //         });
  //         if (
  //           filteredToDo[0].activity.based_on === "Container" &&
  //           groups.todo_performances.length > 0
  //         ) {
  //           handleAssetTypes(groups.todo_performances);
  //         }
  //         if (groups.todo_performances.length > 0)
  //           files = groups.todo_performances[0].files;
  //       } else {
  //         dispatch({
  //           type: GET_ALL_TODO_PERFORMANCE,
  //           payload: [],
  //         });
  //       }

  //       var filedata = provideIdtoAllFile(
  //         filteredToDo[0].activity?.activity_file_uploads,
  //         files
  //       );
  //       dispatch({
  //         type: GET_ALL_FILE_NAME,
  //         payload: filedata,
  //       });
  //       dispatch({
  //         type: GET_ALL_TODO_CUSTOM_COMPONENTS,
  //         payload: filteredToDo[0].activity?.activitycustomfields,
  //       });
  //       setTodoId(filteredToDo[0].activity?.activity_id);
  //     } else {
  //       dispatch({ type: GET_ALL_TODO_DATA, payload: activities[0] });
  //       let files = [];
  //       if (activities[0].todo_performance_groups.length > 0) {
  //         let groups = activities[0].todo_performance_groups[0];
  //         dispatch({
  //           type: GET_ALL_TODO_PERFORMANCE_GROUP,
  //           payload: groups,
  //         });
  //         dispatch({
  //           type: GET_ALL_TODO_PERFORMANCE,
  //           payload: groups.todo_performances,
  //         });
  //         if (
  //           activities[0].activity.based_on === "Container" &&
  //           groups.todo_performances.length > 0
  //         ) {
  //           handleAssetTypes(groups.todo_performances);
  //         }
  //         if (groups.todo_performances.length > 0)
  //           files = groups.todo_performances[0].files;
  //       } else {
  //         dispatch({
  //           type: GET_ALL_TODO_PERFORMANCE,
  //           payload: [],
  //         });
  //       }
  //       var filedata = provideIdtoAllFile(
  //         activities[0].activity?.activity_file_uploads,
  //         files
  //       );
  //       dispatch({
  //         type: GET_ALL_FILE_NAME,
  //         payload: filedata,
  //       });
  //       dispatch({
  //         type: GET_ALL_TODO_CUSTOM_COMPONENTS,
  //         payload: activities[0].activity?.activitycustomfields,
  //       });
  //       setTodoId(activities[0].activity?.activity_id);
  //     }
  //   }
  // }

  const checkLocked = (activities) => {
    for (let i = 0; i < activities.length; i++) {
      if (!activities[i].can_perform) {
        return i;
      }
    }
  };

  const provideIdtoAllFile = (filedata, files) => {
    var arr = [];
    filedata?.forEach((ele) => {
      const findfiles = files?.filter(
        (item) => item.activity_file_upload_id === ele.activity_file_upload_id
      );
      if (findfiles.length > 0) {
        const files = [];
        findfiles.forEach((e1) => {
          files.push({ name: e1.file_name });
        });
        ele.upload = files;
      } else ele.upload = [];
      arr.push(ele);
    });
    return arr;
  };

  /*------------------- Functions to Fill status color ----------------- */
  const statusOuterColor = (status) => {
    switch (status) {
      case "pending": {
        return "border-[--bg-color-500]";
      }

      case "completed": {
        return "border-[--bg-color-500]";
      }
      
      case "completed with delay": {
        return "border-[--bg-color-500]";
      }

      case "completed without data": {
        return "border-[--bg-color-500]";
      }

      case "in progress": {
        return "border-[--bg-color-500]";
      }

      case "overdue": {
        return "border-[#D31313]";
      }

      case "overdue-inprogress": {
        return "border-[#D31313]";
      }

      case "overdue-completed": {
        return "border-[#D31313]";
      }

      case "tentative": {
        return "border-[--bg-color-500] border-dotted";
      }

      default:
        break;
    }
  };

  const status_fill_Color1 = (status, isSelected) => {
    switch (status) {
      case "pending": {
        return "";
      }

      case "completed": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "completed with delay": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "completed without data": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "in progress": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "overdue": {
        return "";
      }

      case "overdue-inprogress": {
        return isSelected ? "ba-white" : "bg-[#D31313]";
      }

      case "overdue-completed": {
        return isSelected ? "ba-white" : "bg-[#D31313]";
      }

      default:
        break;
    }
  };

  const status_fill_Color2 = (status, isSelected) => {
    switch (status) {
      case "pending": {
        return "";
      }

      case "completed": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "completed with delay": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "completed without data": {
        return isSelected ? "bg-white" : "bg-[--bg-color-500]";
      }

      case "in progress": {
        return "";
      }

      case "overdue": {
        return "";
      }

      case "overdue-inprogress": {
        return "";
      }

      case "overdue-completed": {
        return isSelected ? "bg-white" : "bg-[#D31313]";
      }

      default:
        break;
    }
  };

  // Function to handle search and filter
  const handleSearchAndFilter = (searchQuery, ToDolistData) => {
    if (searchQuery) {
      const searchResult = ToDolistData.filter((item, index) => {
        return (
          item.activity.todo_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          item.user?.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });
      setAllActivities(searchResult);
    } else {
      setAllActivities(ToDolistData);
    }
  };

  // Setting up lock index
  useEffect(() => {
    setTodoLock(checkLocked(allactivities));
  }, [allactivities]);

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  //function to store status type in checkstatus state
  const handleCheckboxChange = (index, key) => {
    const updatedData = { ...checkboxData };
    updatedData[key][index].checked = !updatedData[key][index].checked;
    setCheckboxData(updatedData);
  };

  // Handle To Do filter
  useEffect(() => {
    const filteredByStatus = activities.filter((item) => {
      const statusChecked = checkboxData["Status"].some((checkbox) => {
        if (checkbox.value === "completed") {
          return (
            (item.status === "completed" ||
              item.status === "completed with delay") &&
            checkbox.checked
          );
        } else {
          return checkbox.value === item.status && checkbox.checked;
        }
      });
      return statusChecked;
    });

    let filteredByAssignment = [];

    if (filteredByStatus.length > 0) {
      if (checkboxData["Assignment"][0].checked) {
        filteredByAssignment = filteredByStatus.filter((todo) => {
          if (todo.user) {
            return todo.user.id === id;
          } else if (todo.department) {
            return user_departments.some(
              (departments) => departments.department_id === todo.department.id
            );
          } else {
            return todo.email === email;
          }
        });
      } else {
        filteredByAssignment = filteredByStatus;
      }
    } else if (checkboxData["Status"].some((checkbox) => checkbox.checked)) {
      filteredByAssignment = [];
    } else {
      if (checkboxData["Assignment"][0].checked) {
        filteredByAssignment = activities.filter((todo) => {
          if (todo.user) {
            return todo.user.id === id;
          } else if (todo.department) {
            return user_departments.some(
              (departments) => departments.department_id === todo.department.id
            );
          } else {
            return todo.email === email;
          }
        });
      } else {
        filteredByAssignment = activities;
      }
    }
    handleSearchAndFilter(debouncedHandleSearch, filteredByAssignment);
  }, [checkboxData, debouncedHandleSearch]);

  const handleClick = (item) => {
    if (item.activity.activity_id === todoid) {
      return;
    }

    dispatch({
      type: GET_ALL_TODO_CUSTOM_COMPONENTS,
      payload: [],
    });

    dispatch({ type: GET_ALL_TODO_DATA, payload: [] });
    dispatch({ type: PERFORMANCE_LOADER, payload: true });

    setTab(1);
    setAllowBasedon(false);
    setTodoId(item.activity.activity_id);
    setValidation([]);
    setAssetEntryValue(prev => {
      return [{ based_on: "" }]
    });
    dispatch({
      type: GET_ALL_TODO_PERFORMANCE,
      payload: [],
    });
    setActiveEntry([]);
    setPerformanceTab(1);
    dispatch(
      getTodoPerformance(
        activity_assignment_id,
        item.activity.activity_id,
        (res) => {
          dispatch({ type: PERFORMANCE_LOADER, payload: false });
        }
      )
    );

    // dispatch({ type: GET_ALL_TODO_DATA, payload: item });
    // let files = [];
    // if (item.todo_performance_groups.length > 0) {
    //   let groups = item.todo_performance_groups[0];
    //   dispatch({
    //     type: GET_ALL_TODO_PERFORMANCE_GROUP,
    //     payload: groups,
    //   });
    //   dispatch({
    //     type: GET_ALL_TODO_PERFORMANCE,
    //     payload: groups.todo_performances,
    //   });
    //   if (
    //     item.activity.based_on === "Container" &&
    //     groups.todo_performances.length > 0
    //   ) {
    //     handleAssetTypes(groups.todo_performances);
    //   } else {
    //     tempdata.forEach((ele) => {
    //       if (ele.type !== undefined) delete ele.type;
    //     });
    //     dispatch({ type: SET_ASSET_TYPES, payload: tempdata });
    //   }
    //   if (groups.todo_performances.length > 0)
    //     files = groups.todo_performances[0].files;
    // } else {
    //   const assetypes = [];
    //   tempdata.forEach((ele1) => {
    //     if (ele1.type !== undefined) delete ele1.type;
    //     assetypes.push(ele1);
    //   });
    //   dispatch({ type: SET_ASSET_TYPES, payload: assetypes });
    //   dispatch({
    //     type: GET_ALL_TODO_PERFORMANCE,
    //     payload: [],
    //   });
    // }
    // const filedata = provideIdtoAllFile(
    //   item.activity.activity_file_uploads,
    //   files
    // );
    // dispatch({
    //   type: GET_ALL_FILE_NAME,
    //   payload: filedata,
    // });
    // dispatch({
    //   type: GET_ALL_TODO_CUSTOM_COMPONENTS,
    //   payload: item.activity.activitycustomfields,
    // });
  };

  const getActivityOwnerName = (item) => {
    if (item.user) {
      return (
        <div
          title={
            type === Customer ? "Assignee not visible" : `@ ${item.user.name}`
          }
          className="space-x-2 overflow-hidden whitespace-nowrap text-ellipsis"
        >
          <span>
            {type === Customer ? "Assignee not visible" : `@ ${item.user.name}`}
          </span>
        </div>
      );
    } else if (item.user_email) {
      return (
        <div
          title={
            type === Customer
              ? "Assignee not visible"
              : `@ ${maskingEmail(item.user_email)}`
          }
          className="space-x-2 overflow-hidden whitespace-nowrap text-ellipsis"
        >
          <span>
            {type === Customer
              ? "Assignee not visible"
              : `@ ${maskingEmail(item.user_email)}`}
          </span>
        </div>
      );
    } else if (item.department) {
      return (
        <div
          title={
            type === Customer
              ? "Assignee not visible"
              : `@ ${item.department.name}`
          }
          className="space-x-2 overflow-hidden whitespace-nowrap text-ellipsis"
        >
          <span>
            {type === Customer
              ? "Assignee not visible"
              : `@ ${item.department.name}`}
          </span>
        </div>
      );
    } else if(item.stakeholder_name){
        return (
          <div
            title={
              type === Customer
                ? "Assignee not visible"
                : `@ ${item.stakeholder_name} ${item.collaborator_id ? item.collaborator.name : ""}`
            }
            className="space-x-2 overflow-hidden whitespace-nowrap text-ellipsis"
          >
            <span>
              {type === Customer
                ? "Assignee not visible"
                : `@ ${item.stakeholder_name} ${item.collaborator_id ? ` - ${item.collaborator.name}` : ""}`}
            </span>
          </div>
        );
    } else if (item.collaborator_id) {
      return (
        <div
          title={
            type === Customer
              ? item.collaborator.type === Customer
                ? "@ Customer"
                : "Assignee not visible"
              : `@ ${item.collaborator.name}`
          }
          className="space-x-2 overflow-hidden whitespace-nowrap text-ellipsis"
        >
          <span>
            {type === Customer
              ? item.collaborator.type === Customer
                ? "@ Customer"
                : "Assignee not visible"
              : `@ ${item.collaborator.name}`}
          </span>
        </div>
      );
    } else return null;
  };

  const maskingEmail = (email) => {
    let maskid = "";
    let prefix = email.substring(0, email.lastIndexOf("@"));
    let postfix = email.substring(email.lastIndexOf("@"));

    for (let i = 0; i < prefix.length; i++) {
      if (i == 0) {
        maskid = maskid + prefix[i].toString();
      } else {
        maskid = maskid + "*";
      }
    }

    maskid = maskid + postfix;
    return maskid;
  };

  const handleAssetTypes = (activityperformance) => {
    const assetypes = [];
    tempdata.forEach((ele1) => {
      const index = activityperformance.findIndex(
        (ele2) => ele1.asset_name + "-" + ele1.asset_type === ele2.value
      );
      if (index !== -1) {
        ele1.type = activityperformance[index].type;
        assetypes.push(ele1);
      } else {
        if (ele1.type !== undefined) delete ele1.type;
        assetypes.push(ele1);
      }
    });
    dispatch({ type: SET_ASSET_TYPES, payload: assetypes });
  };

  useEffect(() => {
    if (todoListRef.current) {
      let todoIndex = activities?.findIndex(
        (item) =>
        !["completed", "completed with delay", "completed without data"].includes(item.status)
      );

      if(todoIndex !== -1){
        const todoId = activities[todoIndex]?.activity?.activity_id;
        if(todoId && !searchParams.get("activity_id")) {
          setTodoId(todoId);
          setActivityID(todoId);
          const targetElement = todoListRef.current.children[todoIndex];
          targetElement?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }else{
          todoIndex = activities?.findIndex(
            (item) => item.activity?.activity_id === activityid);
          const targetElement = todoListRef.current.children[todoIndex];
          targetElement?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    }
  }, [activityid]);

  const getDateForCompleteWithoutData = (index) => {
    let value = "";
    const list = allactivities?.slice(index+1);
    const data = list.find(item => ["completed", "completed with delay"].includes(item.status));
    if(data){
      value = moment(data.performance_date).format("DD-MM-YYYY hh:mm A")
    }
    return value;
  }

  return (
    <div className="pt-[5px]">
      <h4 className="text-sm leading-3 tracking-tight text-[#535860] font-bold border-b border-b-[#D9D9D9] min-h-100 py-2">
        To Dos
      </h4>
      <div className="flex items-center space-x-2 py-2 mt-2">
        <SearchForm
          placeholder="Search"
          formClass="w-full"
          onChange={(e) => {
            const value = sanitizeInput(e.target.value);
            setSearchText(value);
          }}
          value={searchText}
        />
        {type !== Customer && (
          <CheckboxFilter
            checkboxData={checkboxData}
            handleCheckboxChange={handleCheckboxChange}
          />
        )}
      </div>
      <SimpleBarReact style={{ maxHeight: "calc(100vh - 197px)" }}>
        <div ref={todoListRef} className="space-y-2 overflow-x-hidden">
          {allactivities.length > 0 ? (
            allactivities.map((item, index) => {
              if (!item.can_perform || item.status === "tentative") {
                return (
                  <>
                    {todolock === index && (
                      <div className="flex items-center space-x-2">
                        <i className="fas fa-lock text-[#AEAEAE]"></i>
                        <div className="w-full border border-dashed border-[#AEAEAE]"></div>
                      </div>
                    )}
                    <div
                      className={`h-[58px] rounded bg-[#2F80ED0F] opacity-50 cursor-not-allowed ${
                        type === Customer
                          ? item.collaborator_id === id
                            ? "flex items-center"
                            : Number(item.activity.is_trackable)
                            ? "flex items-center"
                            : "hidden"
                          : "flex items-center"
                      } px-4`}
                      onClick={() => {
                        if (item.status === "tentative") return;
                        if (!item.can_perform) return;
                        if (performanceLoader) return;
                        handleClick(item, index);
                      }}
                    >
                      <div className="w-full space-y-1">
                        <div className="flex items-center justify-between">
                          <div className="w-1/2 sm:w-[85%] flex space-x-1 items-center">
                            <p
                              title="Empty Container Pickup"
                              className="text-sm font-semibold leading-5 text-[#1E293B] overflow-hidden whitespace-nowrap text-ellipsis"
                            >
                              {item.activity?.todo_name}
                            </p>
                          </div>
                          <Tippy
                            content={
                              <div className="space-y-1">
                                <div className="grid grid-cols-2 gap-1 text-xs">
                                  <h2>Status:</h2>
                                  <div className="flex justify-start">
                                    <h2 className="capitalize">
                                      {item.status === "completed without data" ? "Completed (Assumed)" : item.status }
                                    </h2>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-1 text-xs">
                                  <h2>End Date:</h2>
                                  <h2>
                                    {item.estimated_time ? moment(item.estimated_time).format(
                                      "DD-MM-YYYY hh:mm A"
                                    ): "To Be Announced" }
                                  </h2>
                                </div>
                                <div className="grid grid-cols-2 gap-1 text-xs">
                                  <h2>Complete Date:</h2>
                                  <h2>
                                    {(item.status === "completed" ||
                                      item.status === "completed with delay") &&
                                    item?.performance_date
                                      ? moment(item.performance_date).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )
                                      : "-"}
                                  </h2>
                                </div>
                              </div>
                            }
                          >
                            <div
                              className={`w-4 h-4 border-3 ${statusOuterColor(
                                item.status
                              )} rounded-full flex`}
                            >
                              <div
                                className={`flex-1 ${status_fill_Color1(
                                  item.status
                                )}`}
                              ></div>
                              <div
                                className={`flex-1 ${status_fill_Color2(
                                  item.status
                                )}`}
                              ></div>
                            </div>
                          </Tippy>
                        </div>
                        <div className="flex items-center justify-between">
                          <p className="text-xs leading-4 w-1/2 text-gray-500 font-normal tracking-tight">
                            {getActivityOwnerName(item)}
                          </p>

                          <Tippy
                            content={
                              <div className="space-y-1">
                                <div className="grid grid-cols-2 gap-1 text-xs">
                                  <h2>Status:</h2>
                                  <div className="flex justify-start">
                                    <h2 className="capitalize">
                                      {item.status === "completed without data" ? "Completed (Assumed)" : item.status }
                                    </h2>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-1 text-xs">
                                  <h2>End Date:</h2>
                                  <h2>
                                    {item.estimated_time ? moment(item.estimated_time).format(
                                      "DD-MM-YYYY hh:mm A"
                                    ) : "To Be Announced"}
                                  </h2>
                                </div>
                                <div className="grid grid-cols-2 gap-1 text-xs">
                                  <h2>Complete Date:</h2>
                                  <h2>
                                    {(item.status === "completed" ||
                                      item.status === "completed with delay") &&
                                    item?.performance_date
                                      ? moment(item.performance_date).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )
                                      : "-"}
                                  </h2>
                                </div>
                              </div>
                            }
                          >
                            <p
                              title={item.estimated_time ? moment(item.estimated_time).format(
                                "DD-MM-YYYY hh:mm A"
                              ) : "To Be Announced"}
                              className={`text-xs font-normal leading-4 tracking-tight text-end ${
                                todoid === item.activity?.activity_id
                                  ? "text-white"
                                  : "text-[#475569] "
                              } whitespace-nowrap w-1/2 truncate`}
                            >
                              {item.status === "completed" ||
                              item.status === "completed with delay" ? (
                                <span
                                  class={`fa-solid fa-check ${
                                    todoid === item.activity?.activity_id
                                      ? "text-white"
                                      : "text-[--bg-color-500]"
                                  }`}
                                ></span>
                              ) : null}
                              &nbsp;
                              {item.estimated_time ? moment(item.estimated_time).format(
                                "DD-MM-YYYY hh:mm A"
                              ) : "To Be Announced" }
                              {/* {type === Customer
                                ? item?.collaborator?.type === Customer
                                  ? moment(item.estimated_time).format(
                                      "DD-MM-YYYY hh:mm A"
                                    )
                                  : "End Date not visible"
                                : moment(item.estimated_time).format(
                                    "DD-MM-YYYY hh:mm A"
                                  )} */}
                            </p>
                          </Tippy>
                        </div>
                      </div>
                    </div>
                  </>
                );
              } else {
                return (
                  <div
                    className={`h-[58px] rounded ${
                      todoid === item.activity?.activity_id
                        ? "bg-[--bg-color-500]"
                        : "bg-[#2F80ED0F]"
                    } cursor-pointer ${
                      type === Customer
                        ? item.collaborator_id === id
                          ? "flex items-center"
                          : Number(item.activity.is_trackable)
                          ? "flex items-center"
                          : "hidden"
                        : "flex items-center"
                    } px-4`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (performanceLoader) return;
                      handleClick(item, index);
                    }}
                  >
                    <div className="w-full space-y-1">
                      <div className="flex items-center justify-between">
                        <div className="w-1/2 sm:w-[85%] flex space-x-1 items-center">
                          <p
                            title={item.activity?.todo_name}
                            className={`text-sm font-semibold leading-5 ${
                              todoid === item.activity?.activity_id
                                ? "text-white"
                                : "text-[#1E293B]"
                            } w-full truncate`}
                          >
                            {item.activity?.todo_name}
                          </p>
                        </div>

                        <Tippy
                          content={
                            <div className="space-y-1">
                              <div className="grid grid-cols-2 gap-1 text-xs">
                                <h2>Status:</h2>
                                <div className="flex justify-start">
                                  <h2 className="capitalize">{item.status === "completed without data" ? "Completed (Assumed)" : item.status }</h2>
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-1 text-xs">
                                <h2>End Date:</h2>
                                <h2>
                                  {item.estimated_time ? moment(item.estimated_time).format(
                                    "DD-MM-YYYY hh:mm A"
                                  ): "To Be Announced"}
                                </h2>
                              </div>
                              <div className="grid grid-cols-2 gap-1 text-xs">
                                <h2>Complete Date:</h2>
                                <h2>
                                  {(item.status === "completed" ||
                                    item.status === "completed with delay") &&
                                  item?.performance_date
                                    ? moment(item.performance_date).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )
                                    : item.status === "completed without data" ? getDateForCompleteWithoutData(index) : "-"}
                                </h2>
                              </div>
                            </div>
                          }
                        >
                          <div
                            className={`w-4 h-4 border-3 ${
                              todoid === item.activity?.activity_id
                                ?  item.status === "tentative" ? "border-white border-dotted" : "border-white"
                                : statusOuterColor(item.status)
                            } rounded-full flex`}
                          >
                            <div
                              className={`flex-1 ${status_fill_Color1(
                                item.status,
                                todoid === item.activity?.activity_id
                              )}`}
                            ></div>
                            <div
                              className={`flex-1 ${status_fill_Color2(
                                item.status,
                                todoid === item.activity?.activity_id
                              )}`}
                            ></div>
                          </div>
                        </Tippy>
                      </div>
                      <div className="flex items-center justify-between">
                        <p
                          className={`text-xs leading-4 font-bold  w-1/2 ${
                            todoid === item.activity?.activity_id
                              ? "text-white"
                              : "text-[--bg-color-500]"
                          } tracking-tight`}
                        >
                          {getActivityOwnerName(item)}
                        </p>
                        <Tippy
                          content={
                            <div className="space-y-1">
                              <div className="grid grid-cols-2 gap-1 text-xs">
                                <h2>Status:</h2>
                                <div className="flex justify-start">
                                  <h2 className="capitalize">{item.status === "completed without data" ? "Completed (Assumed)" : item.status }</h2>
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-1 text-xs">
                                <h2>End Date:</h2>
                                <h2>
                                  { item.estimated_time ? moment(item.estimated_time).format(
                                    "DD-MM-YYYY hh:mm A"
                                  ) : "To Be Announced" }
                                </h2>
                              </div>
                              <div className="grid grid-cols-2 gap-1 text-xs">
                                <h2>Complete Date:</h2>
                                <h2>
                                  {(item.status === "completed" ||
                                    item.status === "completed with delay") &&
                                  item?.performance_date
                                    ? moment(item.performance_date).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )
                                    : "-"}
                                </h2>
                              </div>
                            </div>
                          }
                        >
                          <p
                            // title={["completed", "completed with delay"].includes(item.status)
                            //   ? moment(item.performance_date).format("DD-MM-YYYY hh:mm A")
                            //   : moment(item.estimated_time).format("DD-MM-YYYY hh:mm A")}
                            className={`text-xs font-normal leading-4 tracking-tight text-end ${
                              todoid === item.activity?.activity_id
                                ? "text-white"
                                : "text-[#475569] "
                            } whitespace-nowrap w-1/2 truncate`}
                          >
                            {item.status === "completed" ||
                            item.status === "completed with delay" ||
                            item.status === "completed without data" ? (
                              <span
                                class={`fa-solid fa-check ${
                                  todoid === item.activity?.activity_id
                                    ? "text-white"
                                    : "text-[--bg-color-500]"
                                }`}
                              ></span>
                            ) : null}
                            &nbsp;
                            { ["completed", "completed with delay"].includes(item.status)
                                ? moment(item.performance_date).format("DD-MM-YYYY hh:mm A")
                                :  item.status === "completed without data" ? getDateForCompleteWithoutData(index) : item.estimated_time ? moment(item.estimated_time).format("DD-MM-YYYY hh:mm A") : "To Be Announced"
                            }
                            {/* {type === Customer
                              ? item?.collaborator?.type === Customer
                                ? moment(item.estimated_time).format(
                                    "DD-MM-YYYY hh:mm A"
                                  )
                                : "End Date not visible"
                              : moment(item.estimated_time).format(
                                  "DD-MM-YYYY hh:mm A"
                                )} */}
                          </p>
                        </Tippy>
                      </div>
                    </div>
                  </div>
                );
              }
            })
          ) : (
            <h2 className="font-semibold text-center">No results found</h2>
          )}
        </div>
      </SimpleBarReact>
    </div>
  );
}

export default ToDoList;
